import * as React from 'react';
import { Modal } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';

export type Props = {
  openModal: boolean;
  wholeBranches?: boolean;
  setIsModalOpen?: (item: boolean) => void;
  confirmModal?: () => void;
};

export const ConfirmChangeBrandModal: React.FC<Props> = props => {
  const { t } = useTranslation('campaigns');

  const closeModal = () => {
    props.setIsModalOpen(false);
  };

  const confirmModal = () => {
    props.setIsModalOpen(false);
    props.confirmModal();
  };

  return (
    <div>
      <Modal
        isOpen={props.openModal}
        heading={
          props.wholeBranches
            ? t('onsite.editor.workflow.confirmDeletWholeBranches.heading')
            : t('onsite.editor.workflow.confirmDeleletIndiviualBranch.heading')
        }
        onOkButtonClicked={confirmModal}
        onCloseButtonClicked={closeModal}
        okButtonLabel={t('onsite.editor.workflow.confirmDeletWholeBranches.confirmButton')}
        okButtonAriaLabel={t('onsite.editor.workflow.confirmDeletWholeBranches.confirmButtonAria')}
        variation="clean"
        size="medium"
      >
        <div>
          {props.wholeBranches
            ? t('onsite.editor.workflow.confirmDeletWholeBranches.body')
            : t('onsite.editor.workflow.confirmDeleletIndiviualBranch.body')}
        </div>
      </Modal>
    </div>
  );
};
